import React, { useEffect } from 'react'
import { graphql, Link } from 'gatsby'
import { withPrismicPreviewResolver } from 'gatsby-plugin-prismic-previews'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import NewsletterForm from 'components/newsletterForm'
import LayoutContent from 'components/layouts/layoutContent'
import AuthorArticle from 'components/blog/authorArticle'
import CardQoveryStarted from 'components/cards/cardQoveryStarted'
import SectionBlog from 'components/sections/sectionBlog'
import Button from 'components/button'
import { COMMON, LINK } from 'utils/intl/common.js'
import { useGlobalState } from 'utils/hooks/globalStateProvider'
import LinkAnimate from 'utils/hooks/linkAnimate'
import { linkResolver } from 'utils/linkResolver'
import { impContent, impContentSummary, convertDate, readingTime } from 'utils'

function Article(props) {
  const { data } = props.data.page
  const dataFooter = props.data.footer.data
  const dataHeader = props.data.header.data
  const breakpoints = useBreakpoint()
  const [, dispatch] = useGlobalState()

  useEffect(() => {
    if (breakpoints.md) {
      const body = document.querySelector('body')
      const wrapper = document.querySelector('.tl-edges')

      body.style.overflow = 'initial'
      wrapper.style.overflow = 'initial'

      return () => {
        body.style.removeProperty('overflow')
        wrapper.style.removeProperty('overflow')
      }
    }
  })

  return (
    <LayoutContent
      data={data}
      dataFooter={dataFooter}
      dataHeader={dataHeader}
      breadcrumbLinks={[{ title: 'Blog', link: 'blog' }]}
    >
      <div className="article__container">
        <div className="container">
          <div className="row">
            <div className="col col-md-8 col-lg-6 col--center">
              <div className="article__head">
                <h1 className="mt-3 mb-3 c-text-black-lighter">{data.title.text}</h1>
                <div className="article__content">
                  <div>{impContent(data.description.raw, dispatch)}</div>
                </div>
                <div className="f--tablet f-jc-space-b f-align-items-center">
                  {data.author.document && (
                    <LinkAnimate
                      to={`author/${data.author.document.uid}`}
                      className="f f-align-items-center mb-1 mb-md-0"
                    >
                      <img
                        loading="lazy"
                        className="img-circle img-circle--small mr-3"
                        src={data.author.document.data.picture.url}
                        alt={data.author.document.data.name.text}
                      />
                      <p className="c-text-black-lighter ft-secondary ft-500 mb-0">
                        {data.author.document.data.name.text}
                      </p>
                    </LinkAnimate>
                  )}
                  <span className="f ft-secondary c-text-black-lightest">
                    {convertDate(data.date)} · {readingTime(data.content.text)} {COMMON.MIN_READ}{' '}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="article__cover mt-3 mb-3" style={{ background: data.cover_background_color || '#0e101f' }}>
          <div className="row">
            <div className="col col-md-10 col-lg-8 col--center">
              <img loading="lazy" src={data.cover.url} alt={`${data.title.text} - Qovery`} />
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="f--desktop col col-md-8 col-lg-6 col--center">
              <div className="article__sidebar">
                <div className="article__sidebar__author">
                  {data.author.document && (
                    <div className="f f-direction-column">
                      <span className="f ft-up ft-tertiary c-text-black-lightest ft-600 mb-3">{COMMON.WRITTEN_BY}</span>
                      <LinkAnimate to={`author/${data.author.document.uid}`} className="f mb-1 mb-lg-0">
                        <img
                          loading="lazy"
                          className="img-circle img-circle--big mb-2"
                          src={data.author.document.data.picture.url}
                          alt={data.author.document.data.name.text}
                        />
                      </LinkAnimate>
                      <h4 className="h5 ft-600 c-text-black-lighter mb-1">{data.author.document.data.name.text}</h4>
                      <p className="ft-tertiary c-text-black-lightest mb-2">
                        {data.author.document.data.description.text}
                      </p>
                      <LinkAnimate className="btn btn--secondary" to={`author/${data.author.document.uid}`}>
                        {COMMON.SEE_ALL_ARTICLES}
                      </LinkAnimate>
                      <hr className="mt-3 mb-3" />
                      <div className="f f-flow-wrap mb-4">
                        {data.tags.map((tag) => (
                          <span key={tag.block} className="tag tag--cat mb-1 mr-2">
                            {tag.block}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
                <div className="article__sidebar__summary">
                  <span className="f ft-up ft-tertiary c-text-black-lightest ft-600 mb-2">{COMMON.SUMMARY}</span>
                  {impContentSummary(data.content.raw)}
                </div>
              </div>
              <div className="article__content">
                <div>{impContent(data.content.raw, dispatch)}</div>
                {(data.demo_card || data.demo_card === null) && (
                  <CardQoveryStarted
                    className="card-q-started--article mt-5"
                    title={data.demo_card_title ? data.demo_card_title.text : null}
                    description={data.demo_card_paragraph ? data.demo_card_paragraph.text : null}
                  />
                )}
              </div>
              <div className="article__started">
                <div>
                  <img className="mb-1" loading="lazy" src="../../../images/logo-black.svg" alt="Qovery white logo" />
                  <h4 className="ft-600 c-text-black-lighter mb-1">{COMMON.TITLE_STARTED}</h4>
                  <p className="ft-tertiary c-text-black-lightest mb-2">
                    Qovery is a{' '}
                    <Link title="DevOps Automation Platform" className="link c-brand-500" to="/">
                      DevOps Automation Platform
                    </Link>{' '}
                    Helping 200+ Organizations To Ship Faster and Eliminate DevOps Hiring Needs,
                  </p>
                  <Button className="btn btn--medium btn--full f-jc-space-c" url={LINK.QOVERY_CONSOLE}>
                    {COMMON.DEPLOY_MY_APPS}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="article__bottom">
        <div className="container">
          <div className="row">
            <div className="col col-md-8 col-lg-6 col--center">
              <div className="f mb-5">
                {data.tags.map((tag) => (
                  <span key={tag.block} className="tag tag--cat mr-2">
                    {tag.block}
                  </span>
                ))}
              </div>
              <NewsletterForm />
              {data.author.document && (
                <AuthorArticle
                  title={COMMON.WRITTEN_BY}
                  slug={`author/${data.author.document.uid}`}
                  data={data.author.document.data}
                />
              )}
            </div>
          </div>
        </div>
        {data.more_articles && data.more_articles.length > 0 && (
          <SectionBlog title={COMMON.TITLE_MORE_ARTICLE} data={data.more_articles} />
        )}
      </div>
    </LayoutContent>
  )
}

export const queryArticle = graphql`
  query ($uid: String) {
    header: prismicHeader {
      ...prismicHeaderFragment
    }
    page: prismicArticle(uid: { eq: $uid }) {
      ...prismicArticleFragment
    }
    footer: prismicFooter {
      ...prismicFooterFragment
    }
  }
`

export default withPrismicPreviewResolver(Article, [
  {
    repositoryName: process.env.PRISMIC_REPO_NAME,
    linkResolver,
  },
])
